// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"9113f67d","420":"52c8b0e5","750":"ef8d20ef"}[chunkId] + ".chunk.js";
};